export default {
	editButton: "Edit",
};
